import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "46b0607e-5575-49f2-8c1a-0796dc4cf9a8"
// title: "Member Pages"
// type: :html
// key: "member-pages"
// parent_id: nil
export function MemberPages46b0607e557549f28c1a0796dc4cf9a8(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MemberPages46b0607e557549f28c1a0796dc4cf9a8 gf-page-layout`}>
      {props["header"] || <MembersAreaHeader43272a23Dc5e424fAa51376dc174c038 parentTag="Header11674a29D8994b08A901Dfa9f9409a0a" {...props} />}
      {props["secondary-nav"] || <SecondaryNavigation className="SecondaryNav8974b628A3014eabAe2a46fac512725c" parentTag={buildClassName("SecondaryNav8974b628A3014eabAe2a46fac512725c", parentTag)} {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="FooterBd74435d32544555800e49e89113674f" {...props} />}
    </div>
  );
}

// id: "946cb7c8-0ebd-4db9-be95-58d7f5d47f1d"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d site-header`}>
      <div className="background-color" />
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopDaf0d96aBb7841679ca543d79ad27e79 parentTag="HeaderTopCfec495b7592482c84b9A60ec4078678" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHeroC5d3b9698c2242819adaEc7d180c2ae5 parentTag="Hero8c001a6b84a04735B37c6f24df1bb341" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "11674a29-d899-4b08-a901-dfa9f9409a0a"
// title: ""
// type: :reference
// key: "header"
// parent_id: "46b0607e-5575-49f2-8c1a-0796dc4cf9a8"
export function Header11674a29D8994b08A901Dfa9f9409a0a(props: any) {
  return (
    <MembersAreaHeader43272a23Dc5e424fAa51376dc174c038 parentTag="Header11674a29D8994b08A901Dfa9f9409a0a" {...props} />
  );
}

// id: "bd74435d-3254-4555-800e-49e89113674f"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "46b0607e-5575-49f2-8c1a-0796dc4cf9a8"
export function FooterBd74435d32544555800e49e89113674f(props: any) {
  return (
    <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="FooterBd74435d32544555800e49e89113674f" {...props} />
  );
}

// id: "e0c155f4-49a4-4caf-b594-6904c3b3ad3b"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "30159c9c-07fe-49d3-9d69-f70d3a727136"
export function WelcomeBackE0c155f449a44cafB5946904c3b3ad3b(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBackE0c155f449a44cafB5946904c3b3ad3b" parentTag={buildClassName("WelcomeBackE0c155f449a44cafB5946904c3b3ad3b", parentTag)} {...props} />
  );
}

// id: "e42ce2cf-a27d-4be1-8d82-c2ccee3bab6a"
// title: ""
// type: :reference
// key: "label"
// parent_id: "2e4a2261-2ce2-4f63-af66-c232cea54bdd"
export function LabelE42ce2cfA27d4be18d82C2ccee3bab6a(props: any) {
  return (
    <DefaultLogo8badf4b943014befBf583972f24e76b2 parentTag="LabelE42ce2cfA27d4be18d82C2ccee3bab6a" {...props} />
  );
}

// id: "302ee785-344f-4f61-b60d-96fca7198b15"
// title: "Common Footer"
// type: :reference
// key: "footer"
// parent_id: nil
export function Footer302ee785344f4f61B60d96fca7198b15(props: any) {
  return (
    <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="Footer302ee785344f4f61B60d96fca7198b15" {...props} />
  );
}

// id: "95a3cd6d-23ab-4a35-9fb6-65d396ec1c82"
// title: "Marketing Cards Body"
// type: :html
// key: "marketing-body"
// parent_id: nil
export function MarketingBody95a3cd6d23ab4a359fb665d396ec1c82(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MarketingBody95a3cd6d23ab4a359fb665d396ec1c82 page-body`}>
      {props["marketing-cards"] || <MarketingCards className="MarketingCards5b396f614d5b4896Bafe318d7ba36d8c" parentTag={buildClassName("MarketingCards5b396f614d5b4896Bafe318d7ba36d8c", parentTag)} {...props} />}
    </div>
  );
}

// id: "daf0d96a-bb78-4167-9ca5-43d79ad27e79"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopDaf0d96aBb7841679ca543d79ad27e79(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopDaf0d96aBb7841679ca543d79ad27e79 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo2e4a22612ce24f63Af66C232cea54bdd" parentTag={buildClassName("LinkedLogo2e4a22612ce24f63Af66C232cea54bdd", parentTag)} label={<DefaultLogo8badf4b943014befBf583972f24e76b2 parentTag="LabelE42ce2cfA27d4be18d82C2ccee3bab6a" alt="logo" />} url="/" className="linked-logo" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation6189a198A83b41669d7460ecf189b54b" parentTag={buildClassName("Navigation6189a198A83b41669d7460ecf189b54b", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "7e76801b-c835-4839-88e6-86d366472183"
// title: "Secondary Marketing Header Reference"
// type: :reference
// key: "header"
// parent_id: nil
export function Header7e76801bC835483988e686d366472183(props: any) {
  return (
    <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header7e76801bC835483988e686d366472183" {...props} />
  );
}

// id: "702f3b3f-e6a9-4c33-b679-2eceafad6e06"
// title: ""
// type: :html
// key: "social-links"
// parent_id: "0e538499-5249-461f-aae0-8df92f56e2c4"
export function SocialLinks702f3b3fE6a94c33B6792eceafad6e06(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SocialLinks702f3b3fE6a94c33B6792eceafad6e06 flex flex-row justify-center gap-6 flex flex-row justify-center gap-6`}>
      <a className="hover:brightness-110" href="https://www.instagram.com/sexposla/">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Instagram icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M18.5769 0C8.34616 0 0 8.34616 0 18.5769V45.4423C0 55.6538 8.34616 64 18.5769 64H45.4423C55.6538 64 64 55.6539 64 45.4231V18.5769C64 8.34616 55.6539 0 45.4231 0H18.5769ZM18.5769 4.92308H45.4231C53 4.92308 59.0769 11 59.0769 18.5769V45.4231C59.0769 53 53 59.0769 45.4423 59.0769H18.5769C11 59.0769 4.92308 53 4.92308 45.4423V18.5769C4.92308 11 11 4.92308 18.5769 4.92308ZM51.6923 9.84615C50.3269 9.84615 49.2308 10.9423 49.2308 12.3077C49.2308 13.6731 50.3269 14.7692 51.6923 14.7692C53.0577 14.7692 54.1538 13.6731 54.1538 12.3077C54.1538 10.9423 53.0577 9.84615 51.6923 9.84615ZM32 14.7692C22.5192 14.7692 14.7692 22.5192 14.7692 32C14.7692 41.4808 22.5192 49.2308 32 49.2308C41.4808 49.2308 49.2308 41.4808 49.2308 32C49.2308 22.5192 41.4808 14.7692 32 14.7692ZM32 19.6923C38.8269 19.6923 44.3077 25.1731 44.3077 32C44.3077 38.8269 38.8269 44.3077 32 44.3077C25.1731 44.3077 19.6923 38.8269 19.6923 32C19.6923 25.1731 25.1731 19.6923 32 19.6923Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.facebook.com/groups/1104997742859454">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Facebook icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M32 0C14.356 0 0 14.356 0 32C0 49.644 14.356 64 32 64C49.644 64 64 49.644 64 32C64 14.356 49.644 0 32 0ZM32 4.92308C46.9833 4.92308 59.0769 17.0167 59.0769 32C59.0769 45.6189 49.0711 56.8173 36 58.75V39.8269H43.6442L44.8462 32.0673H36V27.8173C36 24.5927 37.0495 21.7308 40.0673 21.7308H44.9135V14.9519C44.0618 14.8387 42.2625 14.5865 38.8558 14.5865C31.7468 14.5865 27.5769 18.3428 27.5769 26.8942V32.0577H20.2692V39.8269H27.5865V58.6827C14.719 56.5766 4.92308 45.4748 4.92308 32C4.92308 17.0167 17.0167 4.92308 32 4.92308Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://twitter.com/sexposla">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Twitter icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M8 0C3.61317 0 0 3.61317 0 8V56C0 60.3868 3.61317 64 8 64H56C60.3868 64 64 60.3868 64 56V8C64 3.61317 60.3868 0 56 0H8ZM8 5.33333H56C57.5012 5.33333 58.6667 6.49883 58.6667 8V56C58.6667 57.5012 57.5012 58.6667 56 58.6667H8C6.49883 58.6667 5.33333 57.5012 5.33333 56V8C5.33333 6.49883 6.49883 5.33333 8 5.33333ZM41.25 16C36.754 16 33.0988 19.6552 33.1042 24.1458C33.1042 24.9832 33.3958 25.5442 33.3958 26.1042C26.6545 25.8215 21.0557 22.4608 17.125 17.6875C16.2823 18.8128 16 20.2119 16 21.6146C16 24.4199 17.0931 26.6674 19.3438 28.6354C17.8504 28.4328 17.1253 28.0704 16 27.5104C16 31.4411 18.5029 34.527 22.1563 35.375C22.1563 35.375 20.7489 35.6563 19.9063 35.6563C19.2663 35.6563 18.5 35.375 18.5 35.375C19.6253 38.463 22.43 40.9896 26.0833 40.9896C23.278 42.9576 19.6221 44.3542 15.9688 44.3542H14C16.6667 46.6688 20.6635 48 26.3542 48C41.2395 48 49.3958 35.6563 49.3958 24.9896V23.8646C50.8038 22.7393 52.2027 21.3365 53.3333 19.6458C51.648 20.4938 50.2428 20.7694 48.5521 21.0521C50.2374 19.9321 51.6483 18.5252 52.2083 16.5625C50.8057 17.3998 49.1243 18.2382 47.1563 18.5208C45.7483 16.8408 43.5007 16 41.25 16Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.sexpositivelosangeles.org/resources/discord">
        <svg width="64" height="71" viewBox="0 0 64 71" fill="none" xmlns="http://www.w3.org/2000/svg" title="Discord icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M7.11111 0C3.22467 0 0 3.19494 0 7.04555V56.3644C0 60.2127 3.22079 63.4062 7.10417 63.4099L48.6875 63.5063C49.2395 63.5064 49.784 63.3792 50.2778 63.1347L58.2014 69.506C58.7228 69.9259 59.3537 70.1908 60.0208 70.27C60.688 70.3493 61.3641 70.2396 61.971 69.9538C62.5778 69.6679 63.0905 69.2175 63.4496 68.6549C63.8087 68.0922 63.9995 67.4402 64 66.7745V7.04555C64 3.19494 60.7753 0 56.8889 0H7.11111ZM7.11111 7.04555H56.8889V59.3711L50.1667 53.97C49.6617 53.5648 49.0543 53.3044 48.4104 53.2172C47.7666 53.1299 47.1109 53.2191 46.5146 53.4752C45.9184 53.7312 45.4043 54.1442 45.0283 54.6693C44.6523 55.1945 44.4288 55.8117 44.3819 56.4538L7.11806 56.3644C7.11574 56.3644 7.11343 56.3644 7.11111 56.3644V7.04555ZM27.1528 18.1643C22.559 18.6011 19.0694 21.3224 19.0694 21.3224C19.0694 21.3224 14.9333 27.2306 14.2222 38.7712C18.4036 43.5058 24.7292 43.5324 24.7292 43.5324L26.0417 41.7985C24.7012 41.3406 23.5587 40.7531 22.3889 39.8583L22.6319 39.1427C24.8186 40.1326 27.6267 40.7114 32 40.7114C36.3733 40.7114 39.1814 40.1291 41.3681 39.1427L41.6111 39.8583C40.4378 40.7566 39.2952 41.3441 37.9583 41.7985L39.2708 43.5324C39.2708 43.5324 45.5964 43.5058 49.7778 38.7712C49.0667 27.2306 44.9306 21.3224 44.9306 21.3224C44.9306 21.3224 41.2277 18.4884 36.8472 18.1643L35.9444 19.9945C34.604 19.7514 33.2053 19.5748 32 19.5748C30.7556 19.5748 29.3572 19.7415 28.0417 19.967L27.1528 18.1643ZM25.5972 28.1822C27.1617 28.1822 28.4444 29.7604 28.4444 31.705C28.4444 33.6495 27.1617 35.2277 25.5972 35.2277C24.0328 35.2277 22.7569 33.6495 22.7569 31.705C22.7569 29.7604 24.0328 28.1822 25.5972 28.1822ZM38.4028 28.1822C39.9672 28.1822 41.2431 29.7604 41.2431 31.705C41.2431 33.6495 39.9672 35.2277 38.4028 35.2277C36.8383 35.2277 35.5556 33.6495 35.5556 31.705C35.5556 29.7604 36.8383 28.1822 38.4028 28.1822Z" />
        </svg>
      </a>
    </div>
  );
}

// id: "fe53efcf-2bbc-4b4d-b664-4884c8fb534f"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "1d391f29-4b89-4f0b-95f4-90ce996a1fa9"
export function HeroFe53efcf2bbc4b4dB6644884c8fb534f(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="HeroFe53efcf2bbc4b4dB6644884c8fb534f" parentTag={buildClassName("HeroFe53efcf2bbc4b4dB6644884c8fb534f", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "5b396f61-4d5b-4896-bafe-318d7ba36d8c"
// title: "Marketing Cards"
// type: :gf_preset
// key: "marketing-cards"
// parent_id: "95a3cd6d-23ab-4a35-9fb6-65d396ec1c82"
export function MarketingCards5b396f614d5b4896Bafe318d7ba36d8c(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="MarketingCards5b396f614d5b4896Bafe318d7ba36d8c" parentTag={buildClassName("MarketingCards5b396f614d5b4896Bafe318d7ba36d8c", parentTag)} {...props} />
  );
}

// id: "ca3134e0-f99a-42ff-b43b-f8d0e6b343c8"
// title: ""
// type: :text
// key: "title"
// parent_id: "8424e9e6-d91c-4e69-a304-94b90a29ecdb"
export const TitleCa3134e0F99a42ffB43bF8d0e6b343c8 = "Secondary Page";

// id: "43272a23-dc5e-424f-aa51-376dc174c038"
// title: "Members Area Header"
// type: :reference
// key: "members-area-header"
// parent_id: nil
export function MembersAreaHeader43272a23Dc5e424fAa51376dc174c038(props: any) {
  return (
    <ShortHeaderAfe2e848B67642fe8d7aBaac1efcd5c0 parentTag="MembersAreaHeader43272a23Dc5e424fAa51376dc174c038" header-top={<DefaultHeaderTopDaf0d96aBb7841679ca543d79ad27e79 parentTag="HeaderTop1afe4cd05b3047b3A56e7facaf5d28c5" navMenuSlug="members-primary-nav" />} {...props} />
  );
}

// id: "c5d3b969-8c22-4281-9ada-ec7d180c2ae5"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHeroC5d3b9698c2242819adaEc7d180c2ae5(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeroC5d3b9698c2242819adaEc7d180c2ae5 hero`}>
      <div className="title">
        {props["title"] || TitleDaae4f12Ddc2473a86c890c443c9a84f}
      </div>
    </div>
  );
}

// id: "6eccd3df-afd2-420c-b2bc-27fdd0015ceb"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "a635e902-fccd-427b-ab27-30bc98452b65"
export function Footer6eccd3dfAfd2420cB2bc27fdd0015ceb(props: any) {
  return (
    <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="Footer6eccd3dfAfd2420cB2bc27fdd0015ceb" {...props} />
  );
}

// id: "f394543a-510f-4448-933f-65c2e01e46a6"
// title: ""
// type: :reference
// key: "header"
// parent_id: "a635e902-fccd-427b-ab27-30bc98452b65"
export function HeaderF394543a510f4448933f65c2e01e46a6(props: any) {
  return (
    <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="HeaderF394543a510f4448933f65c2e01e46a6" title="Public Events" {...props} />
  );
}

// id: "7850eb52-f5b1-481b-a51c-20cddc27aa44"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "bbe9a313-f5ae-430d-9706-5aac0547e7ea"
export const NavMenuSlug7850eb52F5b1481bA51c20cddc27aa44 = "members-primary-nav";

// id: "db1ae8a4-b7f0-4334-ba8f-d14d60483a06"
// title: "Home Page postSlug"
// type: :text
// key: "postSlug"
// parent_id: "46b72b97-acb6-4102-acb9-ea593440430c"
export const PostSlugDb1ae8a4B7f04334Ba8fD14d60483a06 = "home-page-posts2";

// id: "c3dd68a0-c2bb-4c77-ac1b-9fad3c81b260"
// title: "Password Reset Page"
// type: :reference
// key: "password-reset-page"
// parent_id: nil
export function PasswordResetPageC3dd68a0C2bb4c77Ac1b9fad3c81b260(props: any) {
  return (
    <LoginPageD90e7e526dcb4f788e384c4df7d6b581 parentTag="PasswordResetPageC3dd68a0C2bb4c77Ac1b9fad3c81b260" {...props} />
  );
}

// id: "56ba578e-9a76-4534-8e59-5baa46509e99"
// title: "Signup Pages"
// type: :reference
// key: "signup-pages"
// parent_id: nil
export function SignupPages56ba578e9a7645348e595baa46509e99(props: any) {
  return (
    <SecondaryPage2e9e83c1883b46b497771e297313d561 parentTag="SignupPages56ba578e9a7645348e595baa46509e99" header={<SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header10f7c32612554731A63a262f8eaed7b5" title="Join Us" />} {...props} />
  );
}

// id: "2e9e83c1-883b-46b4-9777-1e297313d561"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage2e9e83c1883b46b497771e297313d561(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage2e9e83c1883b46b497771e297313d561 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header8424e9e6D91c4e69A30494b90a29ecdb" title="Secondary Page" {...props} />}
      <div className="text-content">
        {props.children}
      </div>
      {props["footer"] || <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="FooterF8bfbc0f77734313A30eCdd88aa93098" {...props} />}
    </div>
  );
}

// id: "75ff002d-f358-4a59-aca2-33008007b55f"
// title: "Page Quote"
// type: :html
// key: "page-quote"
// parent_id: nil
export function PageQuote75ff002dF3584a59Aca233008007b55f(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PageQuote75ff002dF3584a59Aca233008007b55f`}>
      <div>
      </div>
      <div>
      </div>
    </div>
  );
}

// id: "2e4a2261-2ce2-4f63-af66-c232cea54bdd"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "daf0d96a-bb78-4167-9ca5-43d79ad27e79"
export function LinkedLogo2e4a22612ce24f63Af66C232cea54bdd(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo2e4a22612ce24f63Af66C232cea54bdd" parentTag={buildClassName("LinkedLogo2e4a22612ce24f63Af66C232cea54bdd", parentTag)} label={<DefaultLogo8badf4b943014befBf583972f24e76b2 parentTag="LabelE42ce2cfA27d4be18d82C2ccee3bab6a" alt="logo" />} url="/" className="linked-logo" {...props} />
  );
}

// id: "8c001a6b-84a0-4735-b37c-6f24df1bb341"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "946cb7c8-0ebd-4db9-be95-58d7f5d47f1d"
export function Hero8c001a6b84a04735B37c6f24df1bb341(props: any) {
  return (
    <SecondaryMarketingHeroC5d3b9698c2242819adaEc7d180c2ae5 parentTag="Hero8c001a6b84a04735B37c6f24df1bb341" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "016fa345-4653-41dc-bbbc-d1206d22234c"
// title: ""
// type: :text
// key: "label"
// parent_id: "1a11332e-2246-4bbc-98b1-d83b6acac217"
export const Label016fa345465341dcBbbcD1206d22234c = "Join Us";

// id: "bef4d82d-4d00-4037-8e73-08cf325075ae"
// title: ""
// type: :text
// key: "href"
// parent_id: "1a11332e-2246-4bbc-98b1-d83b6acac217"
export const HrefBef4d82d4d0040378e7308cf325075ae = "/join";

// id: "0e538499-5249-461f-aae0-8df92f56e2c4"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter0e5384995249461fAae08df92f56e2c4(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter0e5384995249461fAae08df92f56e2c4 footer`}>
      {props["social-links"] || <SocialLinks40f25fffF35346f8908056d18bb9006b />}
      {props["links"] || <Navigation className="Links6e4bec5fEdc642ef9fd0C43f8108e01b" parentTag={buildClassName("Links6e4bec5fEdc642ef9fd0C43f8108e01b", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <LogoCdef36c6B2ca431295217d882b13e356 />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright48acef6fF21d477f86ad1e30259b0310" parentTag={buildClassName("Copyright48acef6fF21d477f86ad1e30259b0310", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow953417aeE27248c8Bb50F6be82b07ed2" parentTag={buildClassName("Groupflow953417aeE27248c8Bb50F6be82b07ed2", parentTag)} {...props} />}
    </footer>
  );
}

// id: "dfe68d23-4aac-4ce9-9cf6-0834317c6a55"
// title: "Marketing Cards"
// type: :gf_preset
// key: "marketing-cards"
// parent_id: nil
export function MarketingCardsDfe68d234aac4ce99cf60834317c6a55(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="MarketingCardsDfe68d234aac4ce99cf60834317c6a55" parentTag={buildClassName("MarketingCardsDfe68d234aac4ce99cf60834317c6a55", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" {...props} />
  );
}

// id: "953417ae-e272-48c8-bb50-f6be82b07ed2"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "0e538499-5249-461f-aae0-8df92f56e2c4"
export function Groupflow953417aeE27248c8Bb50F6be82b07ed2(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow953417aeE27248c8Bb50F6be82b07ed2" parentTag={buildClassName("Groupflow953417aeE27248c8Bb50F6be82b07ed2", parentTag)} {...props} />
  );
}

// id: "8974b628-a301-4eab-ae2a-46fac512725c"
// title: ""
// type: :gf_preset
// key: "secondary-nav"
// parent_id: "46b0607e-5575-49f2-8c1a-0796dc4cf9a8"
export function SecondaryNav8974b628A3014eabAe2a46fac512725c(props: any) {
  const SecondaryNavigation = AppStore.presets["SecondaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <SecondaryNavigation className="SecondaryNav8974b628A3014eabAe2a46fac512725c" parentTag={buildClassName("SecondaryNav8974b628A3014eabAe2a46fac512725c", parentTag)} {...props} />
  );
}

// id: "709805e8-d49f-4e01-a499-324014fccca5"
// title: "Members Area"
// type: :html
// key: "members-area-default"
// parent_id: nil
export function MembersAreaDefault709805e8D49f4e01A499324014fccca5(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MembersAreaDefault709805e8D49f4e01A499324014fccca5 page`}>
      {props["header"] || <MembersAreaHeader43272a23Dc5e424fAa51376dc174c038 parentTag="HeaderF7cbd35506f04fce8dc4A5126e894120" navMenuSlug="members-primary-nav" {...props} />}
      {props["footer"] || <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="FooterAb09309746d74d81B31608f120e89e85" {...props} />}
    </div>
  );
}

// id: "259e8ab9-52b6-412b-8039-13c113f4fab1"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage259e8ab952b6412b803913c113f4fab1(props: any) {
  return (
    <SecondaryPage2e9e83c1883b46b497771e297313d561 parentTag="JoinUsPage259e8ab952b6412b803913c113f4fab1" header={<SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header6831bd11A14244c284630f35db792df8" title="Join Us" />} {...props} />
  );
}

// id: "6e4bec5f-edc6-42ef-9fd0-c43f8108e01b"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "0e538499-5249-461f-aae0-8df92f56e2c4"
export function Links6e4bec5fEdc642ef9fd0C43f8108e01b(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links6e4bec5fEdc642ef9fd0C43f8108e01b" parentTag={buildClassName("Links6e4bec5fEdc642ef9fd0C43f8108e01b", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "1afe4cd0-5b30-47b3-a56e-7facaf5d28c5"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "43272a23-dc5e-424f-aa51-376dc174c038"
export function HeaderTop1afe4cd05b3047b3A56e7facaf5d28c5(props: any) {
  return (
    <DefaultHeaderTopDaf0d96aBb7841679ca543d79ad27e79 parentTag="HeaderTop1afe4cd05b3047b3A56e7facaf5d28c5" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "507c1020-ef98-4344-b3dd-48d91aa826fa"
// title: ""
// type: :text
// key: "url"
// parent_id: "2e4a2261-2ce2-4f63-af66-c232cea54bdd"
export const Url507c1020Ef984344B3dd48d91aa826fa = "/";

// id: "3b0d86d6-f3c2-40d1-8688-225c24b1f932"
// title: "Contact Us"
// type: :reference
// key: "contage-us-public"
// parent_id: nil
export function ContageUsPublic3b0d86d6F3c240d18688225c24b1f932(props: any) {
  return (
    <SecondaryPage2e9e83c1883b46b497771e297313d561 parentTag="ContageUsPublic3b0d86d6F3c240d18688225c24b1f932" header={<SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="HeaderC84f516fE39d4704Ba7eD761d70f18db" title="Contact Us" />} {...props} />
  );
}

// id: "40282584-0439-4980-8936-42c72e888130"
// title: "Admin Pages"
// type: :html
// key: "admin-pages"
// parent_id: nil
export function AdminPages4028258404394980893642c72e888130(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AdminPages4028258404394980893642c72e888130 gf-page-layout`}>
      {props.children}
    </div>
  );
}

// id: "2b97af11-d069-4fd4-90d3-91b0414a12bd"
// title: "Home Page Hero"
// type: :html
// key: "home-page-hero"
// parent_id: nil
export function HomePageHero2b97af11D0694fd490d391b0414a12bd(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageHero2b97af11D0694fd490d391b0414a12bd hero`}>
      <div className="title">
        Learn. Play. Grow.
      </div>
      <div className="body">
        Our mission is to change the world by promoting healthy sexuality through community and education.
      </div>
      <div className="button">
        {props["button"] || <Button className="Button1a11332e22464bbc98b1D83b6acac217" parentTag={buildClassName("Button1a11332e22464bbc98b1D83b6acac217", parentTag)} label="Join Us" href="/join" {...props} />}
      </div>
    </div>
  );
}

// id: "7a695aee-e009-4395-a67a-a769f067bb46"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "afe2e848-b676-42fe-8d7a-baac1efcd5c0"
export const BackgroundImage7a695aeeE0094395A67aA769f067bb46 = "https://mp1md-pub.s3.amazonaws.com/spla/images/spla-skyline.jpeg";

// id: "8bb8e1ca-c4c3-4a23-8530-de47a5e0a51e"
// title: "HREF"
// type: :text
// key: "href"
// parent_id: nil
export const Href8bb8e1caC4c34a238530De47a5e0a51e = "/";

// id: "30159c9c-07fe-49d3-9d69-f70d3a727136"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage30159c9c07fe49d39d69F70d3a727136(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage30159c9c07fe49d39d69F70d3a727136 page gf-page-layout page gf-page-layout`}>
      {props["header"] || <HomeHeader1d391f294b894f0b95f490ce996a1fa9 parentTag="HeaderA04b2e2e204f4c4995e8Aed7f920e1ff" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBackE0c155f449a44cafB5946904c3b3ad3b" parentTag={buildClassName("WelcomeBackE0c155f449a44cafB5946904c3b3ad3b", parentTag)} {...props} />}
      {props["body"] || <MarketingBody95a3cd6d23ab4a359fb665d396ec1c82 parentTag="Body46b72b97Acb64102Acb9Ea593440430c" postSlug="home-page-posts2" {...props} />}
      {props["quote"] || <Quote85c7b6c19145472fB0fdA5adc44edf5b />}
      {props["footer"] || <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="FooterAe29ae32Ff004cf0A76789e82f6c9ba1" {...props} />}
    </div>
  );
}

// id: "84a057ed-9bd5-4544-9ecf-b37fbc4994fb"
// title: ""
// type: :reference
// key: "header"
// parent_id: "2eacc84d-10fa-423c-a17f-4634ebfcf79b"
export function Header84a057ed9bd545449ecfB37fbc4994fb(props: any) {
  return (
    <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header84a057ed9bd545449ecfB37fbc4994fb" title="Resources" {...props} />
  );
}

// id: "a04b2e2e-204f-4c49-95e8-aed7f920e1ff"
// title: ""
// type: :reference
// key: "header"
// parent_id: "30159c9c-07fe-49d3-9d69-f70d3a727136"
export function HeaderA04b2e2e204f4c4995e8Aed7f920e1ff(props: any) {
  return (
    <HomeHeader1d391f294b894f0b95f490ce996a1fa9 parentTag="HeaderA04b2e2e204f4c4995e8Aed7f920e1ff" {...props} />
  );
}

// id: "84327757-b93e-4491-8f11-38183e3bf05e"
// title: ""
// type: :text
// key: "title"
// parent_id: "5e4f7e34-ea69-44ac-93b1-4286146a0a73"
export const Title84327757B93e44918f1138183e3bf05e = "About Us";

// id: "c84f516f-e39d-4704-ba7e-d761d70f18db"
// title: ""
// type: :reference
// key: "header"
// parent_id: "3b0d86d6-f3c2-40d1-8688-225c24b1f932"
export function HeaderC84f516fE39d4704Ba7eD761d70f18db(props: any) {
  return (
    <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="HeaderC84f516fE39d4704Ba7eD761d70f18db" title="Contact Us" {...props} />
  );
}

// id: "b6ad4e65-72a3-4752-89fa-8df440ba0a83"
// title: ""
// type: :text
// key: "title"
// parent_id: "c84f516f-e39d-4704-ba7e-d761d70f18db"
export const TitleB6ad4e6572a3475289fa8df440ba0a83 = "Contact Us";

// id: "afe2e848-b676-42fe-8d7a-baac1efcd5c0"
// title: "Short Header"
// type: :html
// key: "short-header"
// parent_id: nil
export function ShortHeaderAfe2e848B67642fe8d7aBaac1efcd5c0(props: any) {
  const Link = AppStore.presets["Link"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} ShortHeaderAfe2e848B67642fe8d7aBaac1efcd5c0 site-header`}>
      <div className="background-image" />
      <div className="header-top">
        {props["linked-logo"] || <Link className="LinkedLogoE633eb39A48c475d8193Fe43f27fbbca" parentTag={buildClassName("LinkedLogoE633eb39A48c475d8193Fe43f27fbbca", parentTag)} label={<DefaultLogo8badf4b943014befBf583972f24e76b2 parentTag="Label88ae202d8eba40d7B169505a83693361" alt="logo" />} {...props} />}
        {props["navigation"] || <PrimaryNavigation className="NavigationBbe9a313F5ae430d97065aac0547e7ea" parentTag={buildClassName("NavigationBbe9a313F5ae430d97065aac0547e7ea", parentTag)} navMenuSlug="members-primary-nav" {...props} />}
      </div>
    </div>
  );
}

// id: "0d7d7f94-fc4c-4e98-8b9d-73c0159c4e03"
// title: "Message Pages"
// type: :html
// key: "message-pages"
// parent_id: nil
export function MessagePages0d7d7f94Fc4c4e988b9d73c0159c4e03(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MessagePages0d7d7f94Fc4c4e988b9d73c0159c4e03 gf-page-layout`}>
      {props["header"] || <MembersAreaHeader43272a23Dc5e424fAa51376dc174c038 parentTag="Header0ec8487803c6463bAbe43ad16c31a33f" {...props} />}
      {props.children}
    </div>
  );
}

// id: "d2344675-199b-41c4-9cff-06193f867e2e"
// title: ""
// type: :html
// key: "social-links"
// parent_id: "0e538499-5249-461f-aae0-8df92f56e2c4"
export function SocialLinksD2344675199b41c49cff06193f867e2e(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SocialLinksD2344675199b41c49cff06193f867e2e flex flex-row justify-center gap-6 flex flex-row justify-center gap-6`}>
      <a className="hover:brightness-110" href="https://www.instagram.com/sexposla/">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Instagram icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M18.5769 0C8.34616 0 0 8.34616 0 18.5769V45.4423C0 55.6538 8.34616 64 18.5769 64H45.4423C55.6538 64 64 55.6539 64 45.4231V18.5769C64 8.34616 55.6539 0 45.4231 0H18.5769ZM18.5769 4.92308H45.4231C53 4.92308 59.0769 11 59.0769 18.5769V45.4231C59.0769 53 53 59.0769 45.4423 59.0769H18.5769C11 59.0769 4.92308 53 4.92308 45.4423V18.5769C4.92308 11 11 4.92308 18.5769 4.92308ZM51.6923 9.84615C50.3269 9.84615 49.2308 10.9423 49.2308 12.3077C49.2308 13.6731 50.3269 14.7692 51.6923 14.7692C53.0577 14.7692 54.1538 13.6731 54.1538 12.3077C54.1538 10.9423 53.0577 9.84615 51.6923 9.84615ZM32 14.7692C22.5192 14.7692 14.7692 22.5192 14.7692 32C14.7692 41.4808 22.5192 49.2308 32 49.2308C41.4808 49.2308 49.2308 41.4808 49.2308 32C49.2308 22.5192 41.4808 14.7692 32 14.7692ZM32 19.6923C38.8269 19.6923 44.3077 25.1731 44.3077 32C44.3077 38.8269 38.8269 44.3077 32 44.3077C25.1731 44.3077 19.6923 38.8269 19.6923 32C19.6923 25.1731 25.1731 19.6923 32 19.6923Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.facebook.com/groups/1104997742859454">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Facebook icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M32 0C14.356 0 0 14.356 0 32C0 49.644 14.356 64 32 64C49.644 64 64 49.644 64 32C64 14.356 49.644 0 32 0ZM32 4.92308C46.9833 4.92308 59.0769 17.0167 59.0769 32C59.0769 45.6189 49.0711 56.8173 36 58.75V39.8269H43.6442L44.8462 32.0673H36V27.8173C36 24.5927 37.0495 21.7308 40.0673 21.7308H44.9135V14.9519C44.0618 14.8387 42.2625 14.5865 38.8558 14.5865C31.7468 14.5865 27.5769 18.3428 27.5769 26.8942V32.0577H20.2692V39.8269H27.5865V58.6827C14.719 56.5766 4.92308 45.4748 4.92308 32C4.92308 17.0167 17.0167 4.92308 32 4.92308Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://twitter.com/sexposla">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Twitter icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M8 0C3.61317 0 0 3.61317 0 8V56C0 60.3868 3.61317 64 8 64H56C60.3868 64 64 60.3868 64 56V8C64 3.61317 60.3868 0 56 0H8ZM8 5.33333H56C57.5012 5.33333 58.6667 6.49883 58.6667 8V56C58.6667 57.5012 57.5012 58.6667 56 58.6667H8C6.49883 58.6667 5.33333 57.5012 5.33333 56V8C5.33333 6.49883 6.49883 5.33333 8 5.33333ZM41.25 16C36.754 16 33.0988 19.6552 33.1042 24.1458C33.1042 24.9832 33.3958 25.5442 33.3958 26.1042C26.6545 25.8215 21.0557 22.4608 17.125 17.6875C16.2823 18.8128 16 20.2119 16 21.6146C16 24.4199 17.0931 26.6674 19.3438 28.6354C17.8504 28.4328 17.1253 28.0704 16 27.5104C16 31.4411 18.5029 34.527 22.1563 35.375C22.1563 35.375 20.7489 35.6563 19.9063 35.6563C19.2663 35.6563 18.5 35.375 18.5 35.375C19.6253 38.463 22.43 40.9896 26.0833 40.9896C23.278 42.9576 19.6221 44.3542 15.9688 44.3542H14C16.6667 46.6688 20.6635 48 26.3542 48C41.2395 48 49.3958 35.6563 49.3958 24.9896V23.8646C50.8038 22.7393 52.2027 21.3365 53.3333 19.6458C51.648 20.4938 50.2428 20.7694 48.5521 21.0521C50.2374 19.9321 51.6483 18.5252 52.2083 16.5625C50.8057 17.3998 49.1243 18.2382 47.1563 18.5208C45.7483 16.8408 43.5007 16 41.25 16Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.sexpositivelosangeles.org/resources/discord">
        <svg width="64" height="71" viewBox="0 0 64 71" fill="none" xmlns="http://www.w3.org/2000/svg" title="Discord icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M7.11111 0C3.22467 0 0 3.19494 0 7.04555V56.3644C0 60.2127 3.22079 63.4062 7.10417 63.4099L48.6875 63.5063C49.2395 63.5064 49.784 63.3792 50.2778 63.1347L58.2014 69.506C58.7228 69.9259 59.3537 70.1908 60.0208 70.27C60.688 70.3493 61.3641 70.2396 61.971 69.9538C62.5778 69.6679 63.0905 69.2175 63.4496 68.6549C63.8087 68.0922 63.9995 67.4402 64 66.7745V7.04555C64 3.19494 60.7753 0 56.8889 0H7.11111ZM7.11111 7.04555H56.8889V59.3711L50.1667 53.97C49.6617 53.5648 49.0543 53.3044 48.4104 53.2172C47.7666 53.1299 47.1109 53.2191 46.5146 53.4752C45.9184 53.7312 45.4043 54.1442 45.0283 54.6693C44.6523 55.1945 44.4288 55.8117 44.3819 56.4538L7.11806 56.3644C7.11574 56.3644 7.11343 56.3644 7.11111 56.3644V7.04555ZM27.1528 18.1643C22.559 18.6011 19.0694 21.3224 19.0694 21.3224C19.0694 21.3224 14.9333 27.2306 14.2222 38.7712C18.4036 43.5058 24.7292 43.5324 24.7292 43.5324L26.0417 41.7985C24.7012 41.3406 23.5587 40.7531 22.3889 39.8583L22.6319 39.1427C24.8186 40.1326 27.6267 40.7114 32 40.7114C36.3733 40.7114 39.1814 40.1291 41.3681 39.1427L41.6111 39.8583C40.4378 40.7566 39.2952 41.3441 37.9583 41.7985L39.2708 43.5324C39.2708 43.5324 45.5964 43.5058 49.7778 38.7712C49.0667 27.2306 44.9306 21.3224 44.9306 21.3224C44.9306 21.3224 41.2277 18.4884 36.8472 18.1643L35.9444 19.9945C34.604 19.7514 33.2053 19.5748 32 19.5748C30.7556 19.5748 29.3572 19.7415 28.0417 19.967L27.1528 18.1643ZM25.5972 28.1822C27.1617 28.1822 28.4444 29.7604 28.4444 31.705C28.4444 33.6495 27.1617 35.2277 25.5972 35.2277C24.0328 35.2277 22.7569 33.6495 22.7569 31.705C22.7569 29.7604 24.0328 28.1822 25.5972 28.1822ZM38.4028 28.1822C39.9672 28.1822 41.2431 29.7604 41.2431 31.705C41.2431 33.6495 39.9672 35.2277 38.4028 35.2277C36.8383 35.2277 35.5556 33.6495 35.5556 31.705C35.5556 29.7604 36.8383 28.1822 38.4028 28.1822Z" />
        </svg>
      </a>
    </div>
  );
}

// id: "b85665fb-2929-4a62-bd69-67ffbe693188"
// title: ""
// type: :reference
// key: "body"
// parent_id: "a9385e22-d47b-47b7-b823-d77c74cedbbd"
export function BodyB85665fb29294a62Bd6967ffbe693188(props: any) {
  return (
    <MarketingBody95a3cd6d23ab4a359fb665d396ec1c82 parentTag="BodyB85665fb29294a62Bd6967ffbe693188" postSlug="about-page-posts" {...props} />
  );
}

// id: "9b589201-ced2-42f3-ad7c-f0bd8f88cc4e"
// title: ""
// type: :text
// key: "title"
// parent_id: "10f7c326-1255-4731-a63a-262f8eaed7b5"
export const Title9b589201Ced242f3Ad7cF0bd8f88cc4e = "Join Us";

// id: "a9385e22-d47b-47b7-b823-d77c74cedbbd"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPageA9385e22D47b47b7B823D77c74cedbbd(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPageA9385e22D47b47b7B823D77c74cedbbd page gf-page-layout page gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header5e4f7e34Ea6944ac93b14286146a0a73" title="About Us" {...props} />}
      {props["body"] || <MarketingBody95a3cd6d23ab4a359fb665d396ec1c82 parentTag="BodyB85665fb29294a62Bd6967ffbe693188" postSlug="about-page-posts" {...props} />}
      {props["footer"] || <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="Footer544efe9bFcca43a9961162fc142ed408" {...props} />}
    </div>
  );
}

// id: "a635e902-fccd-427b-ab27-30bc98452b65"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPageA635e902Fccd427bAb2730bc98452b65(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPageA635e902Fccd427bAb2730bc98452b65 gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="HeaderF394543a510f4448933f65c2e01e46a6" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="Footer6eccd3dfAfd2420cB2bc27fdd0015ceb" {...props} />}
    </div>
  );
}

// id: "8fb8b544-391f-4778-9fea-020beed9750a"
// title: "Login Header"
// type: :reference
// key: "header"
// parent_id: "d90e7e52-6dcb-4f78-8e38-4c4df7d6b581"
export function Header8fb8b544391f47789fea020beed9750a(props: any) {
  return (
    <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header8fb8b544391f47789fea020beed9750a" title="Login" {...props} />
  );
}

// id: "b77cc8f3-d004-4e6f-9330-ae66f1a9a88f"
// title: "Public Primary Navigation"
// type: :text
// key: "navMenuSlug"
// parent_id: "beedf5dd-48ed-49c2-ae97-98d4fc51df6c"
export const NavMenuSlugB77cc8f3D0044e6f9330Ae66f1a9a88f = "marketing-primary-nav";

// id: "e426d6fa-19d8-4597-810f-b40838d326de"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "fe53efcf-2bbc-4b4d-b664-4884c8fb534f"
export const PostSlugE426d6fa19d84597810fB40838d326de = "home-hero";

// id: "4d40664f-a93f-423c-bea8-0893aa42909c"
// title: "Members Header"
// type: :reference
// key: "header"
// parent_id: nil
export function Header4d40664fA93f423cBea80893aa42909c(props: any) {
  return (
    <MembersAreaHeader43272a23Dc5e424fAa51376dc174c038 parentTag="Header4d40664fA93f423cBea80893aa42909c" {...props} />
  );
}

// id: "bbe9a313-f5ae-430d-9706-5aac0547e7ea"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "afe2e848-b676-42fe-8d7a-baac1efcd5c0"
export function NavigationBbe9a313F5ae430d97065aac0547e7ea(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="NavigationBbe9a313F5ae430d97065aac0547e7ea" parentTag={buildClassName("NavigationBbe9a313F5ae430d97065aac0547e7ea", parentTag)} navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "e633eb39-a48c-475d-8193-fe43f27fbbca"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "afe2e848-b676-42fe-8d7a-baac1efcd5c0"
export function LinkedLogoE633eb39A48c475d8193Fe43f27fbbca(props: any) {
  const Link = AppStore.presets["Link"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogoE633eb39A48c475d8193Fe43f27fbbca" parentTag={buildClassName("LinkedLogoE633eb39A48c475d8193Fe43f27fbbca", parentTag)} label={<DefaultLogo8badf4b943014befBf583972f24e76b2 parentTag="Label88ae202d8eba40d7B169505a83693361" alt="logo" />} {...props} />
  );
}

// id: "f7cbd355-06f0-4fce-8dc4-a5126e894120"
// title: ""
// type: :reference
// key: "header"
// parent_id: "709805e8-d49f-4e01-a499-324014fccca5"
export function HeaderF7cbd35506f04fce8dc4A5126e894120(props: any) {
  return (
    <MembersAreaHeader43272a23Dc5e424fAa51376dc174c038 parentTag="HeaderF7cbd35506f04fce8dc4A5126e894120" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "7c39ac43-3c08-491f-928c-544e9582b2ed"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "1afe4cd0-5b30-47b3-a56e-7facaf5d28c5"
export const NavMenuSlug7c39ac433c08491f928c544e9582b2ed = "members-primary-nav";

// id: "beedf5dd-48ed-49c2-ae97-98d4fc51df6c"
// title: "Default Header Reference"
// type: :reference
// key: "default-header"
// parent_id: nil
export function DefaultHeaderBeedf5dd48ed49c2Ae9798d4fc51df6c(props: any) {
  return (
    <ShortHeaderAfe2e848B67642fe8d7aBaac1efcd5c0 parentTag="DefaultHeaderBeedf5dd48ed49c2Ae9798d4fc51df6c" navMenuSlug="marketing-primary-nav" title {...props} />
  );
}

// id: "1a11332e-2246-4bbc-98b1-d83b6acac217"
// title: ""
// type: :gf_preset
// key: "button"
// parent_id: "2b97af11-d069-4fd4-90d3-91b0414a12bd"
export function Button1a11332e22464bbc98b1D83b6acac217(props: any) {
  const Button = AppStore.presets["Button"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Button className="Button1a11332e22464bbc98b1D83b6acac217" parentTag={buildClassName("Button1a11332e22464bbc98b1D83b6acac217", parentTag)} label="Join Us" href="/join" {...props} />
  );
}

// id: "8b488570-7e29-4863-ba17-9809fe0e616a"
// title: ""
// type: :text
// key: "title"
// parent_id: "946cb7c8-0ebd-4db9-be95-58d7f5d47f1d"
export const Title8b4885707e294863Ba179809fe0e616a = "Secondary Marketing Title 1";

// id: "84ccc0c6-539d-4d5c-a952-3eee708caa87"
// title: ""
// type: :text
// key: "title"
// parent_id: "84a057ed-9bd5-4544-9ecf-b37fbc4994fb"
export const Title84ccc0c6539d4d5cA9523eee708caa87 = "Resources";

// id: "2eacc84d-10fa-423c-a17f-4634ebfcf79b"
// title: "Resources Page"
// type: :reference
// key: "resources-page"
// parent_id: nil
export function ResourcesPage2eacc84d10fa423cA17f4634ebfcf79b(props: any) {
  return (
    <SecondaryPage2e9e83c1883b46b497771e297313d561 parentTag="ResourcesPage2eacc84d10fa423cA17f4634ebfcf79b" header={<SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header84a057ed9bd545449ecfB37fbc4994fb" title="Resources" />} {...props} />
  );
}

// id: "5cf34407-c087-4ed3-b8ee-168e3a7db940"
// title: ""
// type: :text
// key: "alt"
// parent_id: "8badf4b9-4301-4bef-bf58-3972f24e76b2"
export const Alt5cf34407C0874ed3B8ee168e3a7db940 = "logo";

// id: "ab093097-46d7-4d81-b316-08f120e89e85"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "709805e8-d49f-4e01-a499-324014fccca5"
export function FooterAb09309746d74d81B31608f120e89e85(props: any) {
  return (
    <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="FooterAb09309746d74d81B31608f120e89e85" {...props} />
  );
}

// id: "85c7b6c1-9145-472f-b0fd-a5adc44edf5b"
// title: ""
// type: :html
// key: "quote"
// parent_id: "30159c9c-07fe-49d3-9d69-f70d3a727136"
export function Quote85c7b6c19145472fB0fdA5adc44edf5b(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} Quote85c7b6c19145472fB0fdA5adc44edf5b PageQuote`}>
      <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/fDIDlI3qk75Cn3iS_regular.jpeg" className="image opacity" />
      <div className="TextContent">
        Our mission is to change the world by promoting healthy sexuality through community and education.
      </div>
    </div>
  );
}

// id: "879745fa-679a-4df5-b0e2-49bab4b98478"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "6e4bec5f-edc6-42ef-9fd0-c43f8108e01b"
export const NavMenuSlug879745fa679a4df5B0e249bab4b98478 = "footer-nav";

// id: "541bcfe0-e4cc-483e-aba7-eef34b4c5ae9"
// title: "Label"
// type: :reference
// key: "label"
// parent_id: nil
export function Label541bcfe0E4cc483eAba7Eef34b4c5ae9(props: any) {
  return (
    <DefaultLogo8badf4b943014befBf583972f24e76b2 parentTag="Label541bcfe0E4cc483eAba7Eef34b4c5ae9" {...props} />
  );
}

// id: "6189a198-a83b-4166-9d74-60ecf189b54b"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "daf0d96a-bb78-4167-9ca5-43d79ad27e79"
export function Navigation6189a198A83b41669d7460ecf189b54b(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation6189a198A83b41669d7460ecf189b54b" parentTag={buildClassName("Navigation6189a198A83b41669d7460ecf189b54b", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "40f25fff-f353-46f8-9080-56d18bb9006b"
// title: ""
// type: :html
// key: "social-links"
// parent_id: "0e538499-5249-461f-aae0-8df92f56e2c4"
export function SocialLinks40f25fffF35346f8908056d18bb9006b(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SocialLinks40f25fffF35346f8908056d18bb9006b flex flex-row justify-center gap-6 flex flex-row justify-center gap-6`}>
      <a className="hover:brightness-110" href="https://www.instagram.com/sexposla/">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Instagram icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M18.5769 0C8.34616 0 0 8.34616 0 18.5769V45.4423C0 55.6538 8.34616 64 18.5769 64H45.4423C55.6538 64 64 55.6539 64 45.4231V18.5769C64 8.34616 55.6539 0 45.4231 0H18.5769ZM18.5769 4.92308H45.4231C53 4.92308 59.0769 11 59.0769 18.5769V45.4231C59.0769 53 53 59.0769 45.4423 59.0769H18.5769C11 59.0769 4.92308 53 4.92308 45.4423V18.5769C4.92308 11 11 4.92308 18.5769 4.92308ZM51.6923 9.84615C50.3269 9.84615 49.2308 10.9423 49.2308 12.3077C49.2308 13.6731 50.3269 14.7692 51.6923 14.7692C53.0577 14.7692 54.1538 13.6731 54.1538 12.3077C54.1538 10.9423 53.0577 9.84615 51.6923 9.84615ZM32 14.7692C22.5192 14.7692 14.7692 22.5192 14.7692 32C14.7692 41.4808 22.5192 49.2308 32 49.2308C41.4808 49.2308 49.2308 41.4808 49.2308 32C49.2308 22.5192 41.4808 14.7692 32 14.7692ZM32 19.6923C38.8269 19.6923 44.3077 25.1731 44.3077 32C44.3077 38.8269 38.8269 44.3077 32 44.3077C25.1731 44.3077 19.6923 38.8269 19.6923 32C19.6923 25.1731 25.1731 19.6923 32 19.6923Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.facebook.com/groups/1104997742859454">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Facebook icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M32 0C14.356 0 0 14.356 0 32C0 49.644 14.356 64 32 64C49.644 64 64 49.644 64 32C64 14.356 49.644 0 32 0ZM32 4.92308C46.9833 4.92308 59.0769 17.0167 59.0769 32C59.0769 45.6189 49.0711 56.8173 36 58.75V39.8269H43.6442L44.8462 32.0673H36V27.8173C36 24.5927 37.0495 21.7308 40.0673 21.7308H44.9135V14.9519C44.0618 14.8387 42.2625 14.5865 38.8558 14.5865C31.7468 14.5865 27.5769 18.3428 27.5769 26.8942V32.0577H20.2692V39.8269H27.5865V58.6827C14.719 56.5766 4.92308 45.4748 4.92308 32C4.92308 17.0167 17.0167 4.92308 32 4.92308Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://twitter.com/sexposla">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" title="Twitter icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M8 0C3.61317 0 0 3.61317 0 8V56C0 60.3868 3.61317 64 8 64H56C60.3868 64 64 60.3868 64 56V8C64 3.61317 60.3868 0 56 0H8ZM8 5.33333H56C57.5012 5.33333 58.6667 6.49883 58.6667 8V56C58.6667 57.5012 57.5012 58.6667 56 58.6667H8C6.49883 58.6667 5.33333 57.5012 5.33333 56V8C5.33333 6.49883 6.49883 5.33333 8 5.33333ZM41.25 16C36.754 16 33.0988 19.6552 33.1042 24.1458C33.1042 24.9832 33.3958 25.5442 33.3958 26.1042C26.6545 25.8215 21.0557 22.4608 17.125 17.6875C16.2823 18.8128 16 20.2119 16 21.6146C16 24.4199 17.0931 26.6674 19.3438 28.6354C17.8504 28.4328 17.1253 28.0704 16 27.5104C16 31.4411 18.5029 34.527 22.1563 35.375C22.1563 35.375 20.7489 35.6563 19.9063 35.6563C19.2663 35.6563 18.5 35.375 18.5 35.375C19.6253 38.463 22.43 40.9896 26.0833 40.9896C23.278 42.9576 19.6221 44.3542 15.9688 44.3542H14C16.6667 46.6688 20.6635 48 26.3542 48C41.2395 48 49.3958 35.6563 49.3958 24.9896V23.8646C50.8038 22.7393 52.2027 21.3365 53.3333 19.6458C51.648 20.4938 50.2428 20.7694 48.5521 21.0521C50.2374 19.9321 51.6483 18.5252 52.2083 16.5625C50.8057 17.3998 49.1243 18.2382 47.1563 18.5208C45.7483 16.8408 43.5007 16 41.25 16Z" />
        </svg>
      </a>
      <a className="hover:brightness-110" href="https://www.sexpositivelosangeles.org/resources/discord">
        <svg width="64" height="71" viewBox="0 0 64 71" fill="none" xmlns="http://www.w3.org/2000/svg" title="Discord icon" className="fill-current" style={{width: "30px", height: "30px"}}>
          <path d="M7.11111 0C3.22467 0 0 3.19494 0 7.04555V56.3644C0 60.2127 3.22079 63.4062 7.10417 63.4099L48.6875 63.5063C49.2395 63.5064 49.784 63.3792 50.2778 63.1347L58.2014 69.506C58.7228 69.9259 59.3537 70.1908 60.0208 70.27C60.688 70.3493 61.3641 70.2396 61.971 69.9538C62.5778 69.6679 63.0905 69.2175 63.4496 68.6549C63.8087 68.0922 63.9995 67.4402 64 66.7745V7.04555C64 3.19494 60.7753 0 56.8889 0H7.11111ZM7.11111 7.04555H56.8889V59.3711L50.1667 53.97C49.6617 53.5648 49.0543 53.3044 48.4104 53.2172C47.7666 53.1299 47.1109 53.2191 46.5146 53.4752C45.9184 53.7312 45.4043 54.1442 45.0283 54.6693C44.6523 55.1945 44.4288 55.8117 44.3819 56.4538L7.11806 56.3644C7.11574 56.3644 7.11343 56.3644 7.11111 56.3644V7.04555ZM27.1528 18.1643C22.559 18.6011 19.0694 21.3224 19.0694 21.3224C19.0694 21.3224 14.9333 27.2306 14.2222 38.7712C18.4036 43.5058 24.7292 43.5324 24.7292 43.5324L26.0417 41.7985C24.7012 41.3406 23.5587 40.7531 22.3889 39.8583L22.6319 39.1427C24.8186 40.1326 27.6267 40.7114 32 40.7114C36.3733 40.7114 39.1814 40.1291 41.3681 39.1427L41.6111 39.8583C40.4378 40.7566 39.2952 41.3441 37.9583 41.7985L39.2708 43.5324C39.2708 43.5324 45.5964 43.5058 49.7778 38.7712C49.0667 27.2306 44.9306 21.3224 44.9306 21.3224C44.9306 21.3224 41.2277 18.4884 36.8472 18.1643L35.9444 19.9945C34.604 19.7514 33.2053 19.5748 32 19.5748C30.7556 19.5748 29.3572 19.7415 28.0417 19.967L27.1528 18.1643ZM25.5972 28.1822C27.1617 28.1822 28.4444 29.7604 28.4444 31.705C28.4444 33.6495 27.1617 35.2277 25.5972 35.2277C24.0328 35.2277 22.7569 33.6495 22.7569 31.705C22.7569 29.7604 24.0328 28.1822 25.5972 28.1822ZM38.4028 28.1822C39.9672 28.1822 41.2431 29.7604 41.2431 31.705C41.2431 33.6495 39.9672 35.2277 38.4028 35.2277C36.8383 35.2277 35.5556 33.6495 35.5556 31.705C35.5556 29.7604 36.8383 28.1822 38.4028 28.1822Z" />
        </svg>
      </a>
    </div>
  );
}

// id: "0ec84878-03c6-463b-abe4-3ad16c31a33f"
// title: ""
// type: :reference
// key: "header"
// parent_id: "0d7d7f94-fc4c-4e98-8b9d-73c0159c4e03"
export function Header0ec8487803c6463bAbe43ad16c31a33f(props: any) {
  return (
    <MembersAreaHeader43272a23Dc5e424fAa51376dc174c038 parentTag="Header0ec8487803c6463bAbe43ad16c31a33f" {...props} />
  );
}

// id: "1f7a46c8-1411-47b0-974e-dac23c95c723"
// title: "About Page PostSlug"
// type: :text
// key: "postSlug"
// parent_id: "b85665fb-2929-4a62-bd69-67ffbe693188"
export const PostSlug1f7a46c8141147b0974eDac23c95c723 = "about-page-posts";

// id: "d90e7e52-6dcb-4f78-8e38-4c4df7d6b581"
// title: "Login Page"
// type: :html
// key: "login-page"
// parent_id: nil
export function LoginPageD90e7e526dcb4f788e384c4df7d6b581(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <>
      {props["header"] || <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header8fb8b544391f47789fea020beed9750a" title="Login" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="Footer2cee70dc39ac43e1A774D3fd68c2284a" {...props} />}
    </>
  );
}

// id: "10f7c326-1255-4731-a63a-262f8eaed7b5"
// title: ""
// type: :reference
// key: "header"
// parent_id: "56ba578e-9a76-4534-8e59-5baa46509e99"
export function Header10f7c32612554731A63a262f8eaed7b5(props: any) {
  return (
    <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header10f7c32612554731A63a262f8eaed7b5" title="Join Us" {...props} />
  );
}

// id: "46b72b97-acb6-4102-acb9-ea593440430c"
// title: "Home Page Body"
// type: :reference
// key: "body"
// parent_id: "30159c9c-07fe-49d3-9d69-f70d3a727136"
export function Body46b72b97Acb64102Acb9Ea593440430c(props: any) {
  return (
    <MarketingBody95a3cd6d23ab4a359fb665d396ec1c82 parentTag="Body46b72b97Acb64102Acb9Ea593440430c" postSlug="home-page-posts2" {...props} />
  );
}

// id: "5e4f7e34-ea69-44ac-93b1-4286146a0a73"
// title: ""
// type: :reference
// key: "header"
// parent_id: "a9385e22-d47b-47b7-b823-d77c74cedbbd"
export function Header5e4f7e34Ea6944ac93b14286146a0a73(props: any) {
  return (
    <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header5e4f7e34Ea6944ac93b14286146a0a73" title="About Us" {...props} />
  );
}

// id: "19dcee93-24e6-4057-a443-892f081663ab"
// title: ""
// type: :text
// key: "title"
// parent_id: "6831bd11-a142-44c2-8463-0f35db792df8"
export const Title19dcee9324e64057A443892f081663ab = "Join Us";

// id: "30c9998e-2532-4a0e-8920-050059a10df8"
// title: "About Us - Post Slug"
// type: :text
// key: "postSlug"
// parent_id: nil
export const PostSlug30c9998e25324a0e8920050059a10df8 = "about-us-posts";

// id: "f2912719-fb0b-44d3-9f60-84b92984c889"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "1d391f29-4b89-4f0b-95f4-90ce996a1fa9"
export function HeaderTopF2912719Fb0b44d39f6084b92984c889(props: any) {
  return (
    <DefaultHeaderTopDaf0d96aBb7841679ca543d79ad27e79 parentTag="HeaderTopF2912719Fb0b44d39f6084b92984c889" {...props} />
  );
}

// id: "cc94ea6c-dde5-4929-b025-da9eaec8a66a"
// title: ""
// type: :text
// key: "title"
// parent_id: "beedf5dd-48ed-49c2-ae97-98d4fc51df6c"
export const TitleCc94ea6cDde54929B025Da9eaec8a66a = null;

// id: "cdef36c6-b2ca-4312-9521-7d882b13e356"
// title: ""
// type: :html
// key: "logo"
// parent_id: "0e538499-5249-461f-aae0-8df92f56e2c4"
export function LogoCdef36c6B2ca431295217d882b13e356(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/spla/images/spla-logo.png" alt="SPLA logo" className={`${parentTag || ""} LogoCdef36c6B2ca431295217d882b13e356 logo`} />
  );
}

// id: "58a84d6c-64ce-4682-863f-0452b7f7de48"
// title: ""
// type: :text
// key: "title"
// parent_id: "8c001a6b-84a0-4735-b37c-6f24df1bb341"
export const Title58a84d6c64ce4682863f0452b7f7de48 = "Secondary Marketing Title 2";

// id: "8badf4b9-4301-4bef-bf58-3972f24e76b2"
// title: "Logo"
// type: :html
// key: "default-logo"
// parent_id: nil
export function DefaultLogo8badf4b943014befBf583972f24e76b2(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/spla/images/spla-logo.png" className={`${parentTag || ""} DefaultLogo8badf4b943014befBf583972f24e76b2 logo`} alt="logo" />
  );
}

// id: "8424e9e6-d91c-4e69-a304-94b90a29ecdb"
// title: ""
// type: :reference
// key: "header"
// parent_id: "2e9e83c1-883b-46b4-9777-1e297313d561"
export function Header8424e9e6D91c4e69A30494b90a29ecdb(props: any) {
  return (
    <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header8424e9e6D91c4e69A30494b90a29ecdb" title="Secondary Page" {...props} />
  );
}

// id: "daae4f12-ddc2-473a-86c8-90c443c9a84f"
// title: ""
// type: :text
// key: "title"
// parent_id: "c5d3b969-8c22-4281-9ada-ec7d180c2ae5"
export const TitleDaae4f12Ddc2473a86c890c443c9a84f = "Default Title";

// id: "6831bd11-a142-44c2-8463-0f35db792df8"
// title: ""
// type: :reference
// key: "header"
// parent_id: "259e8ab9-52b6-412b-8039-13c113f4fab1"
export function Header6831bd11A14244c284630f35db792df8(props: any) {
  return (
    <SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d parentTag="Header6831bd11A14244c284630f35db792df8" title="Join Us" {...props} />
  );
}

// id: "d02e2bfb-c63e-462b-853f-c6228a2a0f76"
// title: ""
// type: :text
// key: "class"
// parent_id: "2e4a2261-2ce2-4f63-af66-c232cea54bdd"
export const ClassD02e2bfbC63e462b853fC6228a2a0f76 = "linked-logo";

// id: "1d391f29-4b89-4f0b-95f4-90ce996a1fa9"
// title: "Home Header"
// type: :html
// key: "home-header"
// parent_id: nil
export function HomeHeader1d391f294b894f0b95f490ce996a1fa9(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomeHeader1d391f294b894f0b95f490ce996a1fa9 site-header`}>
      <div className="background-color" />
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopDaf0d96aBb7841679ca543d79ad27e79 parentTag="HeaderTopF2912719Fb0b44d39f6084b92984c889" {...props} />}
      </div>
      {props["hero"] || <Hero className="HeroFe53efcf2bbc4b4dB6644884c8fb534f" parentTag={buildClassName("HeroFe53efcf2bbc4b4dB6644884c8fb534f", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "ae29ae32-ff00-4cf0-a767-89e82f6c9ba1"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "30159c9c-07fe-49d3-9d69-f70d3a727136"
export function FooterAe29ae32Ff004cf0A76789e82f6c9ba1(props: any) {
  return (
    <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="FooterAe29ae32Ff004cf0A76789e82f6c9ba1" {...props} />
  );
}

// id: "a41602fa-001c-4254-a450-12e8ba72113d"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "dfe68d23-4aac-4ce9-9cf6-0834317c6a55"
export const ButtonClassA41602fa001c4254A45012e8ba72113d = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "1ad2150b-1913-406e-bc88-8fab608c2a87"
// title: ""
// type: :text
// key: "title"
// parent_id: "f394543a-510f-4448-933f-65c2e01e46a6"
export const Title1ad2150b1913406eBc888fab608c2a87 = "Public Events";

// id: "cfec495b-7592-482c-84b9-a60ec4078678"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "946cb7c8-0ebd-4db9-be95-58d7f5d47f1d"
export function HeaderTopCfec495b7592482c84b9A60ec4078678(props: any) {
  return (
    <DefaultHeaderTopDaf0d96aBb7841679ca543d79ad27e79 parentTag="HeaderTopCfec495b7592482c84b9A60ec4078678" {...props} />
  );
}

// id: "2cee70dc-39ac-43e1-a774-d3fd68c2284a"
// title: "Login Footer"
// type: :reference
// key: "footer"
// parent_id: "d90e7e52-6dcb-4f78-8e38-4c4df7d6b581"
export function Footer2cee70dc39ac43e1A774D3fd68c2284a(props: any) {
  return (
    <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="Footer2cee70dc39ac43e1A774D3fd68c2284a" {...props} />
  );
}

// id: "9c4bd13b-3e5e-4392-98b6-f584f79efefc"
// title: ""
// type: :text
// key: "class"
// parent_id: "6189a198-a83b-4166-9d74-60ecf189b54b"
export const Class9c4bd13b3e5e439298b6F584f79efefc = "navigation";

// id: "88ae202d-8eba-40d7-b169-505a83693361"
// title: ""
// type: :reference
// key: "label"
// parent_id: "e633eb39-a48c-475d-8193-fe43f27fbbca"
export function Label88ae202d8eba40d7B169505a83693361(props: any) {
  return (
    <DefaultLogo8badf4b943014befBf583972f24e76b2 parentTag="Label88ae202d8eba40d7B169505a83693361" {...props} />
  );
}

// id: "f8bfbc0f-7773-4313-a30e-cdd88aa93098"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "2e9e83c1-883b-46b4-9777-1e297313d561"
export function FooterF8bfbc0f77734313A30eCdd88aa93098(props: any) {
  return (
    <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="FooterF8bfbc0f77734313A30eCdd88aa93098" {...props} />
  );
}

// id: "544efe9b-fcca-43a9-9611-62fc142ed408"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "a9385e22-d47b-47b7-b823-d77c74cedbbd"
export function Footer544efe9bFcca43a9961162fc142ed408(props: any) {
  return (
    <DefaultFooter0e5384995249461fAae08df92f56e2c4 parentTag="Footer544efe9bFcca43a9961162fc142ed408" {...props} />
  );
}

// id: "63af4542-2cbb-47a0-a3b9-526e0f947b5a"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "f7cbd355-06f0-4fce-8dc4-a5126e894120"
export const NavMenuSlug63af45422cbb47a0A3b9526e0f947b5a = "members-primary-nav";

// id: "48acef6f-f21d-477f-86ad-1e30259b0310"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "0e538499-5249-461f-aae0-8df92f56e2c4"
export function Copyright48acef6fF21d477f86ad1e30259b0310(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright48acef6fF21d477f86ad1e30259b0310" parentTag={buildClassName("Copyright48acef6fF21d477f86ad1e30259b0310", parentTag)} {...props} />
  );
}

// id: "cb717206-2781-49e1-8b39-96a5adc1c168"
// title: "Login Page Title"
// type: :text
// key: "title"
// parent_id: "8fb8b544-391f-4778-9fea-020beed9750a"
export const TitleCb717206278149e18b3996a5adc1c168 = "Login";

// id: "c9f4fc21-e3f1-4649-bf19-472d84fbccf0"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "6189a198-a83b-4166-9d74-60ecf189b54b"
export const NavMenuSlugC9f4fc21E3f14649Bf19472d84fbccf0 = "marketing-primary-nav";

const Components = {
  MemberPages46b0607e557549f28c1a0796dc4cf9a8,
  SecondaryMarketingHeader946cb7c80ebd4db9Be9558d7f5d47f1d,
  Header11674a29D8994b08A901Dfa9f9409a0a,
  FooterBd74435d32544555800e49e89113674f,
  WelcomeBackE0c155f449a44cafB5946904c3b3ad3b,
  LabelE42ce2cfA27d4be18d82C2ccee3bab6a,
  Footer302ee785344f4f61B60d96fca7198b15,
  MarketingBody95a3cd6d23ab4a359fb665d396ec1c82,
  DefaultHeaderTopDaf0d96aBb7841679ca543d79ad27e79,
  Header7e76801bC835483988e686d366472183,
  SocialLinks702f3b3fE6a94c33B6792eceafad6e06,
  HeroFe53efcf2bbc4b4dB6644884c8fb534f,
  MarketingCards5b396f614d5b4896Bafe318d7ba36d8c,
  TitleCa3134e0F99a42ffB43bF8d0e6b343c8,
  MembersAreaHeader43272a23Dc5e424fAa51376dc174c038,
  SecondaryMarketingHeroC5d3b9698c2242819adaEc7d180c2ae5,
  Footer6eccd3dfAfd2420cB2bc27fdd0015ceb,
  HeaderF394543a510f4448933f65c2e01e46a6,
  NavMenuSlug7850eb52F5b1481bA51c20cddc27aa44,
  PostSlugDb1ae8a4B7f04334Ba8fD14d60483a06,
  PasswordResetPageC3dd68a0C2bb4c77Ac1b9fad3c81b260,
  SignupPages56ba578e9a7645348e595baa46509e99,
  SecondaryPage2e9e83c1883b46b497771e297313d561,
  PageQuote75ff002dF3584a59Aca233008007b55f,
  LinkedLogo2e4a22612ce24f63Af66C232cea54bdd,
  Hero8c001a6b84a04735B37c6f24df1bb341,
  Label016fa345465341dcBbbcD1206d22234c,
  HrefBef4d82d4d0040378e7308cf325075ae,
  DefaultFooter0e5384995249461fAae08df92f56e2c4,
  MarketingCardsDfe68d234aac4ce99cf60834317c6a55,
  Groupflow953417aeE27248c8Bb50F6be82b07ed2,
  SecondaryNav8974b628A3014eabAe2a46fac512725c,
  MembersAreaDefault709805e8D49f4e01A499324014fccca5,
  JoinUsPage259e8ab952b6412b803913c113f4fab1,
  Links6e4bec5fEdc642ef9fd0C43f8108e01b,
  HeaderTop1afe4cd05b3047b3A56e7facaf5d28c5,
  Url507c1020Ef984344B3dd48d91aa826fa,
  ContageUsPublic3b0d86d6F3c240d18688225c24b1f932,
  AdminPages4028258404394980893642c72e888130,
  HomePageHero2b97af11D0694fd490d391b0414a12bd,
  BackgroundImage7a695aeeE0094395A67aA769f067bb46,
  Href8bb8e1caC4c34a238530De47a5e0a51e,
  HomePage30159c9c07fe49d39d69F70d3a727136,
  Header84a057ed9bd545449ecfB37fbc4994fb,
  HeaderA04b2e2e204f4c4995e8Aed7f920e1ff,
  Title84327757B93e44918f1138183e3bf05e,
  HeaderC84f516fE39d4704Ba7eD761d70f18db,
  TitleB6ad4e6572a3475289fa8df440ba0a83,
  ShortHeaderAfe2e848B67642fe8d7aBaac1efcd5c0,
  MessagePages0d7d7f94Fc4c4e988b9d73c0159c4e03,
  SocialLinksD2344675199b41c49cff06193f867e2e,
  BodyB85665fb29294a62Bd6967ffbe693188,
  Title9b589201Ced242f3Ad7cF0bd8f88cc4e,
  AboutUsPageA9385e22D47b47b7B823D77c74cedbbd,
  PublicEventsPageA635e902Fccd427bAb2730bc98452b65,
  Header8fb8b544391f47789fea020beed9750a,
  NavMenuSlugB77cc8f3D0044e6f9330Ae66f1a9a88f,
  PostSlugE426d6fa19d84597810fB40838d326de,
  Header4d40664fA93f423cBea80893aa42909c,
  NavigationBbe9a313F5ae430d97065aac0547e7ea,
  LinkedLogoE633eb39A48c475d8193Fe43f27fbbca,
  HeaderF7cbd35506f04fce8dc4A5126e894120,
  NavMenuSlug7c39ac433c08491f928c544e9582b2ed,
  DefaultHeaderBeedf5dd48ed49c2Ae9798d4fc51df6c,
  Button1a11332e22464bbc98b1D83b6acac217,
  Title8b4885707e294863Ba179809fe0e616a,
  Title84ccc0c6539d4d5cA9523eee708caa87,
  ResourcesPage2eacc84d10fa423cA17f4634ebfcf79b,
  Alt5cf34407C0874ed3B8ee168e3a7db940,
  FooterAb09309746d74d81B31608f120e89e85,
  Quote85c7b6c19145472fB0fdA5adc44edf5b,
  NavMenuSlug879745fa679a4df5B0e249bab4b98478,
  Label541bcfe0E4cc483eAba7Eef34b4c5ae9,
  Navigation6189a198A83b41669d7460ecf189b54b,
  SocialLinks40f25fffF35346f8908056d18bb9006b,
  Header0ec8487803c6463bAbe43ad16c31a33f,
  PostSlug1f7a46c8141147b0974eDac23c95c723,
  LoginPageD90e7e526dcb4f788e384c4df7d6b581,
  Header10f7c32612554731A63a262f8eaed7b5,
  Body46b72b97Acb64102Acb9Ea593440430c,
  Header5e4f7e34Ea6944ac93b14286146a0a73,
  Title19dcee9324e64057A443892f081663ab,
  PostSlug30c9998e25324a0e8920050059a10df8,
  HeaderTopF2912719Fb0b44d39f6084b92984c889,
  TitleCc94ea6cDde54929B025Da9eaec8a66a,
  LogoCdef36c6B2ca431295217d882b13e356,
  Title58a84d6c64ce4682863f0452b7f7de48,
  DefaultLogo8badf4b943014befBf583972f24e76b2,
  Header8424e9e6D91c4e69A30494b90a29ecdb,
  TitleDaae4f12Ddc2473a86c890c443c9a84f,
  Header6831bd11A14244c284630f35db792df8,
  ClassD02e2bfbC63e462b853fC6228a2a0f76,
  HomeHeader1d391f294b894f0b95f490ce996a1fa9,
  FooterAe29ae32Ff004cf0A76789e82f6c9ba1,
  ButtonClassA41602fa001c4254A45012e8ba72113d,
  Title1ad2150b1913406eBc888fab608c2a87,
  HeaderTopCfec495b7592482c84b9A60ec4078678,
  Footer2cee70dc39ac43e1A774D3fd68c2284a,
  Class9c4bd13b3e5e439298b6F584f79efefc,
  Label88ae202d8eba40d7B169505a83693361,
  FooterF8bfbc0f77734313A30eCdd88aa93098,
  Footer544efe9bFcca43a9961162fc142ed408,
  NavMenuSlug63af45422cbb47a0A3b9526e0f947b5a,
  Copyright48acef6fF21d477f86ad1e30259b0310,
  TitleCb717206278149e18b3996a5adc1c168,
  NavMenuSlugC9f4fc21E3f14649Bf19472d84fbccf0
}

export default Components;